/**
 * `PWA-054`/`PWA-055`. Clears only the runtime Cache Storage buckets game
 * code and level data live in -- never the shell's own precache (that is
 * `PWA-062`'s job, the unregister escape hatch, a stronger reset than this
 * control claims to be), and never any storage this file does not name.
 *
 * That second exclusion is the point `PWA-055` exists to make explicit:
 * `ADR-0012` added `TEARDOWN_FALLBACK_KEY` to `localStorage` in the
 * resume-round-trip loop, one stage before this one. A "clear cached data"
 * control wired to `localStorage.clear()` -- an easy, generic-sounding
 * implementation for "clear the cache" -- would silently destroy an
 * in-progress level IndexedDB never received, the exact loss `ADR-0012`
 * exists to prevent. This function never touches `localStorage` or
 * IndexedDB at all, by construction: it calls exactly one Cache Storage API,
 * `caches.delete`, once per named bucket, and nothing else.
 *
 * `pg-game-code` is `offline-availability.ts`'s own constant, reused rather
 * than copied. `pg-level-data` and `pg-images` have no such owner to import
 * from -- they exist only as string literals in `vite.config.ts`'s own
 * `runtimeCaching`, build config this runtime module cannot import, so they
 * are repeated here instead. Kept in sync by `clear-cache.test.ts`, not by
 * a shared constant that cannot exist across that boundary.
 */

import { GAME_CODE_CACHE } from '@platform/offline-availability';

export const RUNTIME_CACHE_NAMES: readonly string[] = [
  GAME_CODE_CACHE,
  'pg-level-data',
  'pg-images',
];

export async function clearCachedGameData(): Promise<void> {
  if (typeof caches === 'undefined') return;
  await Promise.all(RUNTIME_CACHE_NAMES.map((name) => caches.delete(name)));
}
